import { render, staticRenderFns } from "./VisitaCamera.vue?vue&type=template&id=024f868d&scoped=true"
import script from "./VisitaCamera.vue?vue&type=script&lang=js"
export * from "./VisitaCamera.vue?vue&type=script&lang=js"
import style0 from "./VisitaCamera.vue?vue&type=style&index=0&id=024f868d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f868d",
  null
  
)

export default component.exports